import initialState from "./defaultState";
import Vue from "vue";

export default {
    resetStateMutation(state) {
        const defaultState = initialState();

        Object.keys(state).forEach(item => {
            Vue.set(state, item, defaultState[item]);
        })
    },
    setOpenLogHtml(state) {
        state.logGridIsOpen = false;
        state.logHtmlIsOpen = true;
    },
    setCloseLogHtml(state) {
        state.logGridIsOpen = true;
        state.logHtmlIsOpen = false;
    }
}
